module.exports = __webpack_public_path__ + "static/media/brand_logo.3082bd5f.svg";